export default __webpack_public_path__ + "static/media/peter_morley.2a789f83.jpg";